import locale from "../../_util/locale";
/**
 * 用户自定义传入的 org id 格式为 id_org
 * 选中 org id 格式为 id_org_num
 * 统一成 id_org_
 * @param id 组织架构、群、成员 id
 */
function idTrans(id: string) {
    let _id = id;
    if (id.includes("-org-")) {
        _id = `${id.split("-org-")[0]}-org-`;
    }
    if (id.includes("-partner-")) {
        _id = `${id.split("-partner-")[0]}-partner-`;
    }
    return _id;
}

/**
 * 判断是否有效的链接
 * @param {*} url
 */
const validProtocolReg = (url: string) => {
    return /^(http|https)/.test(url);
};

/**
 * 群类型
 * type:
 * 0 - 普通群
 * 1 - 部门群
 * 3 - 审批群
 * 4 - 项目群
 * 5 - 密聊群
 * 9 - 日程群
 * 101 - 面试群（模版群其中的一种）
 */
const TeamType = {
    generalTeam: "0",
    departmentTeam: "1",
    approvalTeam: "3",
    secretChatTeam: "5",
    calendarTeam: "9",
};

/**
 * 群分类
 * group_cate:
 * 1 - 会话群
 * 2 - 话题群
 */
const GroupCate = {
    sessionGroup: 1,
    squad: 2,
};

// 标签域名
const tagDomain = "https://yach-file-keepforever.zhiyinlou.com/vika_upload/";

const DEFAULT_USER_IMG =
    "https://yach-static.zhiyinlou.com/7590830a823ed4fcba8cef3f41b1daa0.png";

/**
 * pageTab 列表(不是所有的页面都有tab的，所以只有这几个page)
 * - 常用联系人：commonlyContact
 * - 我的伙伴：myPartner
 * - 外部联系人：externalContact
 * - 最近会话：recentSession
 * - 我的群组：myGroup
 */
const PageTabInfo = {
    commonlyContact: {
        tab_id: 1,
        tab_name: locale("useradd_all_contacts"),
        key: "commonlyContact",
    },
    myPartner: {
        tab_id: 2,
        tab_name: locale("useradd_type_partner"),
        key: "myPartner",
    },
    externalContact: {
        tab_id: 3,
        tab_name: locale("useradd_type_contact"),
        key: "externalContact",
    },
    recentSession: {
        tab_id: 4,
        tab_name: locale("useradd_type_session"),
        key: "recentSession",
    },
    myGroup: {
        tab_id: 5,
        tab_name: locale("useradd_type_group"),
        key: "myGroup",
    },
};

/**
 * 搜索模式的tab 列表
 */
const SearchTabInfo = {
    user: {
        tab_id: 1,
        tab_name: locale("search_tab_title_user"),
        key: "user",
    },
    group: {
        tab_id: 2,
        tab_name: locale("search_tab_title_group"),
        key: "group",
    },
    // org: {
    //     tab_id: 3,
    //     tab_name: locale("search_tab_title_org"),
    //     key: "org",
    // },
};

/**
 * 搜索状态
 */
const SEARCH_STATUS = {
    /** 尚未输入关键词的初始状态 */
    INIT: "Init",
    /** 已经输入关键词，等待防抖结束 */
    WAIT: "Wait",
    /** 搜索中 */
    SEARCHING: "Searching",
    /** 搜索完成 */
    DONE: "Done",
};

/**
 * 搜索类型（埋点所需）
 */
const SearchTypeForTrack = {
    user: 102,
    group: 103,
};

/**
 * 检查元素是否真正可见
 * 遍历元素及其所有祖先元素，检查是否被隐藏
 * 用于键盘导航时判断当前列表组件是否可见
 *
 * @param element - 要检查的 HTML 元素
 * @returns 元素是否可见
 */
export const isElementVisible = (element: HTMLElement | null): boolean => {
    if (!element) return false;

    // 检查元素本身及所有祖先
    let current: HTMLElement | null = element;
    while (current) {
        // 检查常用的隐藏类名
        if (current.classList.contains('hide')) return false;
        if (current.classList.contains('ant-tabs-tabpane-hidden')) return false;
        if (current.classList.contains('ant-tabs-tabpane-inactive')) return false;

        // 检查 computed style
        const style = window.getComputedStyle(current);
        if (style.display === 'none') return false;
        if (style.visibility === 'hidden') return false;

        current = current.parentElement;
    }

    // 检查元素是否有实际尺寸
    if (element.offsetWidth === 0 || element.offsetHeight === 0) return false;

    return true;
};

/**
 * 获取项目类型：部门、群、人
 * 根据ID字符串模式判断项目类型
 *
 * @param {string | number} id - 项目ID
 * @returns {'org' | 'team' | 'user'} 项目类型，默认为 'user'
 */
export const getItemType = (id: string | number): 'org' | 'team' | 'user' => {
    const idStr = id.toString();
    if (idStr.includes('-org-')) {
        return 'org';
    } else if (idStr.includes('-team-')) {
        return 'team';
    } else if (idStr.includes('-user-')) {
        return 'user';
    }
    return 'user';
};

export {
    idTrans,
    validProtocolReg,
    TeamType,
    GroupCate,
    tagDomain,
    PageTabInfo,
    DEFAULT_USER_IMG,
    SearchTabInfo,
    SEARCH_STATUS,
    SearchTypeForTrack,
};
